<template>
    <v-container fluid>
    <v-row class="mb-3" no-gutters>
      <h2 class="text-h4">{{$t('campaigns.scheduled.list')}}</h2>
      
      <v-spacer />
      <action-button
        button-class="mr-1"
        @click="refreshCampaigns"
        :loading="refreshing"
        icon="$refresh"
        :tooltip="$t('campaigns.refresh')"
        fab
        small
      />
      <action-button
        :to="{ name: 'add-campaign', params: { type: type }}"
        icon="$add"
        :tooltip="$t('campaigns.scheduled.add')"
        color="success"
        fab
        small
        dark
      />
      
    </v-row>

    <v-card id="pfid1618852597" class="pb-3 mb-3">
      <v-card-title>{{$t('common.filter')}}</v-card-title>

    <campaigns-filter id="pfid1618852601" :filters="coloredFilters" v-model="activeFilter"/>
     
    </v-card>

    <v-data-table
    id="pfid1618852608" 
    v-if="list"
    :headers="headers"
    :items="list"
    :search="activeFilter"
    :custom-filter="filterCampaigns"
    >

    <template v-slot:item.name="i">
        <router-link v-if="i.item.state !='INCOMPLETE'" :to="{name: 'campaign-detail', params: {campaign: i.item.id }}">{{ i.item.name }}</router-link>
        <router-link v-else :to="getCampaignStep(i.item)">{{ i.item.name }}</router-link>
    </template>

    <template v-slot:item.state="i">
      <v-chip outlined :color="getCampaignStateColor(i.item.state)">
        {{ getCampaignStateText(i.item.state).toUpperCase() }}
      </v-chip>
    </template>

    <template #item.segmentationType="i">
      {{ i.item ? formatSegmentationType(i.item.segmentationType) : null }}
    </template>

    <template #item.schedule="i">
      {{ i.item && i.item.schedule && i.item.schedule.start ? formatDate(i.item.schedule.start) : null }}
    </template>
    
    <template v-slot:item.actions="i">
        <action-button class="pfcl1618852617" v-if="i.item.state=='WAITING'" icon="$pause" :tooltip="$t('campaigns.actions.pause')" @click="disableCampaign(i.item.id)" />
        <action-button class="pfcl1618852620" v-else-if="i.item.state == 'DISABLED' || i.item.state == 'INCOMPLETE'" icon="$edit" :tooltip="$t('campaigns.actions.edit')" :to="getCampaignStep(i.item)" />
        <action-button class="pfcl1618852624" icon="$copy" :tooltip="$t('campaigns.actions.duplicate')" @click="duplicateCampaign(i.item.id)" />
        <action-button class="pfcl1618852627" v-if="i.item.state == 'INCOMPLETE'" icon="$remove" :tooltip="$t('campaigns.actions.delete.title')" @click="toDelete = i.item.id; confirmDelete = true;" />
        <action-button class="pfcl1618852630" v-else icon="$archive" :tooltip="$t('campaigns.actions.archive.title')" @click="toArchive = i.item.id; confirmArchive = true;" />
      </template>
    </v-data-table>
    <v-skeleton-loader v-else
      type="table"
    ></v-skeleton-loader>
    <confirm-dialog v-model="confirmArchive" @confirm="archiveCampaign(toArchive)">{{$t('campaigns.actions.archive.text')}}</confirm-dialog>
    <confirm-dialog v-model="confirmDelete" @confirm="deleteCampaign(toDelete)">{{$t('campaigns.actions.delete.text')}}</confirm-dialog>
    </v-container>
</template>
<script>

import ParseRoute from "@/mixins/parse-route";
import CampaignLists from "@/mixins/campaign-lists";

  export default {
    name: 'ScheduledCampaigns',
    mixins: [ParseRoute, CampaignLists],
    data() {
      return {
        type: 'scheduled',
        filters: [
          { title: this.$t('campaigns.state.incomplete'), value: 'INCOMPLETE', enabled: true },
          { title: this.$t('campaigns.state.waiting'), value: 'WAITING', enabled: true },
          { title: this.$t('campaigns.state.computing'), value: 'COMPUTING', enabled: true },
          { title: this.$t('campaigns.state.sending'), value: 'SENDING', enabled: true },
          { title: this.$t('campaigns.state.completed'), value: 'COMPLETED', enabled: true },
          { title: this.$t('campaigns.state.paused'), value: 'DISABLED', enabled: true },
          { title: this.$t('campaigns.state.archived'), value: 'ARCHIVED', enabled: false }
        ],
        headers: [
          { value: 'name', text: this.$t('common.name') },
          { value: 'state', text: this.$t('common.state') },
          { value: 'schedule', text: this.$t('campaigns.started') },
          { value: 'actions', text: this.$t('common.actions'), align: 'end' }
        ]
      };
    },
  }
</script>